import React, { useMemo } from 'react'
import classNames from 'classnames'
import { toNumber } from 'lodash'

import { determineGradient } from '@/components/helpers'
import { convertAgentNameToInitials } from '@/utils/helpers'

import './UserInitial.scss'

/**
 * @import import { UserInitial } from '@/components/UserInitial'
 * @param {object} props
 * @param {string} [props.userFullName] Full name converted to initials
 * @param {number} [props.index=0] Rotates through the gradient palette
 * @param {boolean} [props.inline] Overlapping stack layout for rows of avatars
 * @param {number} [props.overflowCount] Renders +N on a neutral background instead of initials for hidden users
 * @param {boolean} [props.small] Shrinks the avatar to sit in a line of text, beside a name
 */
export const UserInitial = ({ userFullName, index, inline, overflowCount, small }) => {
  const gradient = useMemo(() => determineGradient(toNumber(index || 0)), [index])

  if (!userFullName && !overflowCount) {
    return null
  }

  return (
    <div data-testid="user-initial" className={classNames('user-initials-container', { inline })}>
      <div
        className={classNames('user-initials', { small })}
        data-testid="user-initial-content"
        style={{ background: overflowCount ? 'var(--color-background-strong)' : gradient }}
      >
        {overflowCount ? `+${overflowCount}` : convertAgentNameToInitials(userFullName)}
      </div>
    </div>
  )
}
